export default "__VITE_ASSET__CJy$40_Z__"